module.exports = __webpack_public_path__ + "img/login-cover@2x.2b6803fb.png";